/**
 * Approach Page - Training methodology and philosophy
 */

import { useTheme } from '../contexts/ThemeContext';
import {
  PageLayout,
  PageHeader,
  Card,
  Button,
  Text,
  Heading
} from '../components';
import styles from './Approach.module.css';

const Approach = () => {
  const { theme } = useTheme();

  return (
    <PageLayout className="approach-page">
      <PageHeader
        title="OUR APPROACH"
        subtitle="How we develop young soccer talent"
      />



      {/* Call to Action */}
      <Card variant="transparent" padding="3rem 2rem" className={styles.ctaCard}>
        <Heading
          level={2}
          style={{
            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
            marginBottom: theme.spacing.lg,
            color: theme.colors.primary
          }}
        >
          Ready to Start?
        </Heading>
        <Text
          variant="large"
          align="center"
          style={{
            marginBottom: theme.spacing.xl,
            maxWidth: '600px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          Whether your child is just starting out or looking to take their game to the next level,
          we are here to support their journey with personalized training and genuine care.
        </Text>
        <Button variant="primary" size="large" href="/programs">
          View Programs
        </Button>
      </Card>
    </PageLayout>
  );
};

export default Approach;
